import { func, number, string } from 'prop-types'
import { useEffect, useState } from 'react'
import Button from '../../Button'
import Alert from '../index'
import { styles } from './styles'

export const formatAsMinutes = (seconds) => {
  const date = new Date(0)
  date.setSeconds(seconds)

  const timeString = date.toISOString().substr(14, 5)
  return timeString
}

export const countdownTimer = ({ seconds, setSeconds, destroySession }) => {
  const interval = setInterval(() => {
    setSeconds(seconds - 1)
  }, 1000)

  if (seconds === 0) {
    clearInterval(interval)
    destroySession()
  }

  return () => clearInterval(interval)
}

export const CountDownAlert = ({
  alertTitle,
  cancelButtonText,
  confirmButtonText,
  destroySession,
  formatTime = formatAsMinutes,
  keepSession,
  secondsRemaining,
  textAfterTime,
  textBeforeTime,
}) => {
  const [seconds, setSeconds] = useState(secondsRemaining)
  useEffect(
    () => countdownTimer({ seconds, setSeconds, destroySession }),
    [seconds, setSeconds, destroySession]
  )

  return (
    <Alert
      style={styles}
      title={alertTitle}
      message={`${textBeforeTime} ${formatTime(seconds)} ${textAfterTime}`}
    >
      <Button
        className="cancel"
        label={cancelButtonText}
        type="secondary"
        onClick={destroySession}
      />
      <Button label={confirmButtonText} onClick={keepSession} />
    </Alert>
  )
}

CountDownAlert.propTypes = {
  alertTitle: string,
  cancelButtonText: string,
  confirmButtonText: string,
  destroySession: func,
  formatTime: func,
  keepSession: func,
  secondsRemaining: number,
  textAfterTime: string,
  textBeforeTime: string,
}
